import React from 'react';
import Header from '../../layout/Header'
import MobileNav from '../../layout/MobileNav'
import ButtonLinkLightBlue from '../../components/buttons/ButtonLinkLightBlue';
import {Helmet} from "react-helmet";

const Welcome = () => {

  return (
    <>
        <Helmet>
            <title>Welcome | Oreca Pro</title>
            <link rel="canonical" href={window.location.href} />
        </Helmet>
        <Header />
        <MobileNav />
        <div className="py-[80px] px-5 max-w-[700px] mx-auto pt-[140px] md:pt-[180px]">
            {/* Hero Section */}
            <div className="text-center mb-5">
                <h1 className="text-3xl md:text-4xl font-bold mb-3">
                    Welcome!
                </h1>
                <p className="text-base text-custom-light-grey leading-relaxed mt-10">
                    Oreca Pro rates each surf spot based on <span className="text-custom-light-blue font-semibold">your ideal conditions</span>. 
                    Set your preferences for wave height, wind direction, swell period, and more—everything is 
                    <span className="text-custom-light-blue font-semibold"> fully customizable</span> to match your personal taste and skill level.
                </p>
            </div>

            {/* Call to Action */}
            <div className="text-center mt-12">
                <ButtonLinkLightBlue href="/" text="Get Started" />
            </div>
        </div>
    </>
  );
};

export default Welcome;
